/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TransferCustomersControllerGetCustomerOfficeAdminsQueryResponse, TransferCustomersControllerGetCustomerOfficeAdminsPathParams, TransferCustomersControllerGetCustomerOfficeAdmins401, TransferCustomersControllerGetCustomerOfficeAdmins403 } from "../../models/transferCustomersController/TransferCustomersControllerGetCustomerOfficeAdmins";

function getTransferCustomersControllerGetCustomerOfficeAdminsUrl(salesforceId: TransferCustomersControllerGetCustomerOfficeAdminsPathParams["salesforceId"]) {
  const res = { method: 'GET', url: `/api/v1/transfer-customers/${salesforceId}/office-admins` as const }  
  return res
}

/**
 * @summary Get distinct active office administrators for a customer (1.0 teams + svc-permissions)
 * {@link /api/v1/transfer-customers/:salesforceId/office-admins}
 */
export async function transferCustomersControllerGetCustomerOfficeAdmins(salesforceId: TransferCustomersControllerGetCustomerOfficeAdminsPathParams["salesforceId"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<TransferCustomersControllerGetCustomerOfficeAdminsQueryResponse, ResponseErrorConfig<TransferCustomersControllerGetCustomerOfficeAdmins401 | TransferCustomersControllerGetCustomerOfficeAdmins403>, unknown>({ method : "GET", url : getTransferCustomersControllerGetCustomerOfficeAdminsUrl(salesforceId).url.toString(), ... requestConfig })  
  return res.data
}